module.exports = __webpack_public_path__ + "img/IRangedMonkey64_ua.5fa44a8c.webp";